import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

import { ColorForm } from "./colorForm";
import { Props } from "./types";
import styles from "./styles.scss";

function ZoneCreationForm(props: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.zoneCreationForm}>
      <div className={styles.group}>
        <h2 className={styles.title}>{t("zoneCreation.nameTitle")}</h2>
        <div className={styles.row}>
          <ColorForm
            zone={props.zone}
            selectedColor={props.zone.color}
            selectColor={(color) => props.editForm({ ...props.zone, color })}
          />
          <div className={styles.name}>
            <input
              value={props.zone.name}
              placeholder={t("zoneCreation.namePlaceholder")}
              className={styles.input}
              onChange={({ target }) =>
                props.editForm({ ...props.zone, name: target.value })
              }
              autoFocus
            />
          </div>
        </div>
      </div>
      <div className={styles.group}>
        <h2 className={styles.title}>{t("zoneCreation.descriptionTitle")}</h2>
        <textarea
          value={props.zone.description}
          placeholder={t("zoneCreation.descriptionPlaceholder")}
          className={classNames(styles.input, styles.textArea)}
          onChange={({ target }) =>
            props.editForm({ ...props.zone, description: target.value })
          }
        />
      </div>
    </div>
  );
}

export { ZoneCreationForm };
